import { Mutation } from 'vuex';
import { IModuleState } from './types';

// 列表
export const setMaterials: Mutation<IModuleState> = (state, payload) => {
  state.list.data = payload.data;
  state.list.total = payload.total;
  state.list.pageNum = payload.pageNum;
  state.list.pageSize = payload.pageSize;
  state.list.loading = !!payload.loading;
};

// 详情
export const setMaterialDetail: Mutation<IModuleState> = (state, payload) => {
  state.detail.data = payload.data;
  state.detail.loading = payload.loading;
};

// 实例
export const setInstances: Mutation<IModuleState> = (state, payload) => {
  state.instances.data = payload.data;
  state.instances.loading = payload.loading;
};

// 贴图配置
export const setMaterialConfigure: Mutation<IModuleState> = (state, payload) => {
  state.configure.data = payload.data;
  state.configure.loading = payload.loading;
};

// 品牌详情
export const setBrandDetail: Mutation<IModuleState> = (state, payload) => {
  state.brand.data = payload.data;
  state.brand.loading = payload.loading;
};

// 材料类型
export const setMatItemTypes: Mutation<IModuleState> = (state, payload) => {
  state.matItemTypes.data = payload.data;
  state.matItemTypes.loading = payload.loading;
};

// 缩略图
export const setMaterialThumb: Mutation<IModuleState> = (state, payload) => {
  state.thumb.data = payload.data;
  state.thumb.loading = payload.loading;
};

// 颜色信息
export const setMaterialColor: Mutation<IModuleState> = (state, payload) => {
  state.colors.data = payload.data;
  state.colors.loading = payload.loading;
};

// 过滤项列表
export const setMaterialFilters: Mutation<IModuleState> = (state, payload) => {
  state.filters.data = payload.data;
  state.filters.loading = !!payload.loading;
};

// confirm 弹窗
export const setConfirm: Mutation<IModuleState> = (state, payload) => {
  state.confirm.visible = !!payload.visible;
  state.confirm.loading = !!payload.loading;
  state.confirm.title = payload.title || '';
  state.confirm.content = payload.content || '';
  state.confirm.name = payload.name || '';
};

// 设置列表搜索条件
export const setSearchParams: Mutation<IModuleState> = (state, payload) => {
  state.searchParams = payload;
};

export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loading = payload;
};
